import { render, staticRenderFns } from "./invite-modal.vue?vue&type=template&id=0131a587&scoped=true&"
import script from "./invite-modal.vue?vue&type=script&lang=ts&"
export * from "./invite-modal.vue?vue&type=script&lang=ts&"
import style0 from "./invite-modal.vue?vue&type=style&index=0&id=0131a587&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0131a587",
  null
  
)

export default component.exports